import React from "react";
import { connect } from "react-redux";

import Col from "antd/es/col";
import Row from "antd/es/row";
import Switch from "antd/es/switch";
import { useIntl } from "react-intl";

import TextWithInfo from "@app/component/typography/TextWithInfo";
import localSettings from "@app/config/LocalSettings";
import { updateToken } from "@app/store/auth/actions";
import layout from "@app/styles/layout";

import styles from "./AnonymousSwitcher.module.scss";

interface Props {
  updateToken: typeof updateToken;
}

const AnonymousSwitcher: React.FC<Props> = ({ updateToken }) => {
  const intl = useIntl();

  if (!localSettings.wasSkeletonKeyUsed()) {
    return null;
  }

  return (
    <Row align="middle" gutter={layout.spacerM}>
      <Col>
        <TextWithInfo
          className={styles.container}
          info={intl.formatMessage(
            {
              id: "settings.header.anonymousSwitcher.info",
              defaultMessage:
                "INTERNAL MESSAGE | MAP MY CUSTOMERS {br}You signed into this account using a skeleton key. Turn on this setting to anonymize all data in this account.",
              description: "Settings anonymous Switcher - info",
            },
            { br: <br /> }
          )}
          placeIconOnLeftSide
          placement="bottom"
          tooltipOverlayClassName={styles.tooltip}
        >
          {intl.formatMessage({
            id: "settings.header.anonymousSwitcher.text",
            defaultMessage: "Anonymous Mode",
            description: "Settings anonymous Switcher - text",
          })}
        </TextWithInfo>
      </Col>
      <Col>
        <Switch defaultChecked={localSettings.isAnonymousFlagRaised()} onChange={updateToken} />
      </Col>
    </Row>
  );
};

const mapDispatchToProps = {
  updateToken,
};

export default connect(null, mapDispatchToProps)(AnonymousSwitcher);
